<template>
  <SSection v-for="(item, index) in items" :key="index" :has-separator="false">
    <SMediaBanner v-bind="item" />
  </SSection>
</template>
<script setup lang="ts">
import type { propsInterface as sMediaBannerProps } from '~~/modules/design-system/sections/s-media-banner/s-media-banner.vue'

export interface propsInterface {
  items: sMediaBannerProps[]
}

defineProps<propsInterface>()
</script>
